export default "__VITE_ASSET__DLV8fMuW__"